module.exports = __webpack_public_path__ + "static/img/tousu.f79ae7dd.png";